import { render, staticRenderFns } from "./product-solution.vue?vue&type=template&id=61c8b1a9&scoped=true&"
import script from "./product-solution.vue?vue&type=script&lang=js&"
export * from "./product-solution.vue?vue&type=script&lang=js&"
import style0 from "./product-solution.vue?vue&type=style&index=0&id=61c8b1a9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c8b1a9",
  null
  
)

export default component.exports